"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NgValidators = void 0;
var NgValidators = /** @class */ (function () {
    function NgValidators() {
    }
    NgValidators.validHandicap = function (control) {
        var pattern = /^(-?\d{1,2},\d{1,2})|(-?\d{1,2})$/;
        var strValue = control.value;
        if (!pattern.test(strValue)) {
            return {
                invalidHcp: strValue
            };
        }
        var value = Math.abs(parseFloat(strValue.replace(',', '.')));
        if (isNaN(value) || value > 54) {
            return {
                invalidHcp: strValue
            };
        }
        else if (value >= 0 && value <= 36) {
            if (strValue.indexOf(',') === -1) {
                return {
                    invalidHcp: value
                };
            }
        }
        else if (value >= 36.1 && value <= 36.9) {
            return {
                invalidHcp: value
            };
        }
        else if (value >= 37 && value <= 54) {
            if (strValue.indexOf(',') !== -1) {
                return {
                    invalidHcp: value
                };
            }
        }
        return null;
    };
    return NgValidators;
}());
exports.NgValidators = NgValidators;
